module.exports = __webpack_public_path__ + "static/media/icn_blog.4d30958d.svg";